import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import KvTitleSpImg from 'ui/images/top/kv_title_pc.svg';
import KvTitlePcImg from 'ui/images/top/kv_title_pc.svg';
import KvMainIllustImg from 'ui/images/top/kv_main_illust.png';
import SellerSignUpButtonPcImg from 'ui/images/top/seller_sign_up_button_pc.png';
import SellerSignUpButtonSpImg from 'ui/images/top/seller_sign_up_button_sp.png';
import KvItemAImg from 'ui/images/top/kv_item_a.png';
import KvItemBImg from 'ui/images/top/kv_item_b.png';
import KvItemCImg from 'ui/images/top/kv_item_c.png';
import { mqMin } from 'utils/responsive';
import { useNavigate } from 'react-router-dom';
import { Only } from 'ui/components/elements/Only/Only';

const Container = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    margin: 0 auto 0 auto;
`;

const IllustContainer = styled.div`
    position: relative;
    width: 100%;
    margin: 0 auto;
    top: 10rem;
    text-align: center;

    ${mqMin('NARROW')} {
        top: 4rem;
    }
`;

const H2 = styled.h2`
    width: 20rem;
    margin: 0 auto 19px auto;
    animation: kvFadein 0.5s linear 1.6s forwards;
    opacity: 0;

    ${mqMin('SP')} {
        width: 35rem;
        margin: 3rem auto 0 auto;
    }

    ${mqMin('NARROW')} {
        width: 38rem;
        position: relative;
        margin: 0 auto;
        animation: kvFadein 0.5s linear 1.6s forwards;
    }

    img {
        width: 100%;
        height: auto;
    }
`;

const MainIllust = styled.div`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    animation: kvFadein 0.4s linear 2.2s forwards;

    ${mqMin('NARROW')} {
        position: relative;
    }
`;

const LinkContainer = styled.div`
    opacity: 0;
    position: absolute;
    display: block;
    top: 10.3rem;
    left: 50%;
    z-index: 10;
    transform: translateX(-50%);
    width: 19rem;
    justify-content: center;
    overflow: visible;
    animation: kvFadein 0.5s linear 1.6s forwards;
    pointer-events: auto;
    cursor: pointer;
    &:hover {
        transform: translateX(-50%) scale(1.01);
        transition: transform 0.2s ease-in-out;
    }

    ${mqMin('SP')} {
        width: 26rem;
        top: 7.7rem;
    }

    ${mqMin('NARROW')} {
        width: 38rem;
        position: absolute;
        top: 14.3rem;
        display: flex;
        overflow: hidden;
        margin-top: 0;
        pointer-events: auto;
        animation: kvFadein 0.4s linear 2.2s forwards;

        a::before {
            animation: kvBtn 1s ease-in-out 2.6s;
        }
    }
`;

const KvMainPersonImg = styled.img`
    height: auto;
    width: 19rem;
    margin: 0 auto;
    max-width: initial !important;

    ${mqMin('SP')} {
        width: 25rem;
        top: -4.5rem;
        position: relative;
    }

    ${mqMin('NARROW')} {
        width: 26rem;
        top: initial;
    }
`;

const KvItemImg = styled.img`
   width: 20.5rem;
    top: -0.6rem;
    left: 0.2rem;
    height: auto;
    max-width: initial !important;
    position: absolute;
    transform: translateX(-50%);

    ${mqMin('SP')} {
        width: 27rem;
        left: 0.8rem;
        top: -5rem;
    }

    ${mqMin('NARROW')} {
        width: 27.5rem;
        top: -0.7rem;
        left: 0.8rem;
    }
`;

const FadeWrap = styled.div<{ visible: boolean }>`
    transition: opacity 1s;
    opacity: ${({ visible }) => (visible ? 1 : 0)};
    position: absolute;
    pointer-events: none;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
`;

const KvSpSetSwitcher: React.FC = () => {
    const SETS = [
        [(current: number) => <KvItemImg key={`img1-${current}`} src={KvItemAImg} alt="選択肢A" />],
        [(current: number) => <KvItemImg key={`img2-${current}`} src={KvItemBImg} alt="選択肢B" />],
        [(current: number) => <KvItemImg key={`img3-${current}`} src={KvItemCImg} alt="選択肢C" />],
    ];
    const [current, setCurrent] = useState(0);
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrent((prev) => (prev + 1) % SETS.length);
        }, 3500);
        return () => clearInterval(timer);
    }, []);
    return (
        <>
            {SETS.map((set, idx) => (
                <FadeWrap key={idx} visible={idx === current}>
                    {idx === current && set.map((fn) => fn(current))}
                </FadeWrap>
            ))}
        </>
    );
};

export const KvMainText: React.FC = () => {
    const navigate = useNavigate();

    const goToRegister = () => {
        navigate('/send-registration-mail/');
    };
    return (
        <Container>
            <H2>
                <picture>
                    <source media="(max-width: 1023px)" srcSet={KvTitleSpImg} />
                    <source media="(min-width: 1024px)" srcSet={KvTitlePcImg} />
                    <img src={KvTitlePcImg} alt="複数の仲介会社と無料でセカンドオピニオンできます" />
                </picture>
            </H2>

            <IllustContainer>
                <MainIllust>
                    <KvSpSetSwitcher />
                    <KvMainPersonImg src={KvMainIllustImg} alt="複数の仲介会社と無料でセカンドオピニオンできます" />
                </MainIllust>
                <LinkContainer onClick={goToRegister}>
                    <Only pc>
                        <img src={SellerSignUpButtonPcImg} alt="売り手企業の登録はこちら" />
                    </Only>
                    <Only sp>
                        <img src={SellerSignUpButtonSpImg} alt="売り手企業の登録はこちら" />
                    </Only>
                </LinkContainer>
            </IllustContainer>
        </Container>
    );
};
